import {
  MediaData,
  OrderedResponseNodeData,
  OrderedResponseData,
  MultipleChoiceMediaData,
} from '../../../types/quiz';
import { parseMainExp, parseStringWithNode } from './utils';

/**
 * OrderData.
 */
export const mapOrderedData = ({
  data,
  mediaData,
}: {
  data: OrderedResponseNodeData;
  mediaData: MediaData<MultipleChoiceMediaData[]>;
}): OrderedResponseData => {
  return {
    question: parseStringWithNode(data.q, mediaData),
    mainExplanation: parseMainExp(data.e || '', mediaData),
    keyTakeaway: parseMainExp(data.kp || '', mediaData),
    answerOrder: 0,
    answers: data.a.map((a) => ({
      explanation: parseStringWithNode(a.exp, mediaData) || '',
      text: a.name || '',
      correctValue: Number(a.correctValue),
    })),
  };
};
